export const CGIAR_COLORS = ['#006837', '#007DBC', '#F37021', '#FDB913', '#3B9B61', '#8B5CF6', '#EF4444', '#14B8A6'];

export const LABEL_STYLE = { fontSize: 11, fill: '#666' };

// Theme-aware Recharts tooltip style — reads CSS custom properties at render time
export function getTooltipStyle() {
  return {
    borderRadius: '8px',
    border: `1px solid var(--tooltip-border, #e5e7eb)`,
    backgroundColor: `var(--tooltip-bg, #ffffff)`,
    color: `var(--tooltip-text, #0f172a)`,
  };
}

export const TRAFFIC_HEX = { green: '#16a34a', yellow: '#ca8a04', red: '#dc2626', unknown: '#9ca3af' };

export const AOW_CARD_COLORS = {
  header: { bg: '#fef3c7', border: '#d97706', text: '#92400e' },
  outputs: { bg: '#eff6ff', border: '#3b82f6', headerBg: '#bfdbfe', text: '#1d4ed8' },
  outcomes: { bg: '#fff1f2', border: '#881337', headerBg: '#fecdd3', text: '#881337' },
};

export const sortByShortTitle = (a, b) =>
  (a.shortTitle || '').localeCompare(b.shortTitle || '', undefined, { numeric: true });

export const sortByName = (a, b) =>
  a.name.localeCompare(b.name, undefined, { numeric: true });

export function splitHlosByType(hlos) {
  const hloItems = hlos.filter(h => h.resultType && !h.resultType.includes('Intermediate')).sort(sortByShortTitle);
  const iocItems = hlos.filter(h => h.resultType && h.resultType.includes('Intermediate')).sort(sortByShortTitle);
  const untyped = hlos.filter(h => !h.resultType).sort(sortByShortTitle);
  return { outputGroup: [...hloItems, ...untyped], iocItems };
}

export const DELIVERY_TYPE_COLORS = {
  'Demand': '#007DBC',
  'Innovation': '#8B5CF6',
  'Scaling': '#F37021',
  'Not provided': '#a1a1aa',
  'Other': '#908a84',
  'N/A': '#cbd5e1',
};

const GEO_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

// Module-level TopoJSON cache
let _topoCache = null;
let _topoPromise = null;

export function fetchTopoJSON() {
  if (_topoCache) return Promise.resolve(_topoCache);
  if (!_topoPromise) {
    _topoPromise = fetch(GEO_URL)
      .then(res => res.json())
      .then(data => { _topoCache = data; return data; })
      .catch(err => { _topoPromise = null; throw err; });
  }
  return _topoPromise;
}

export function getTopoCache() {
  return _topoCache;
}

// Resolve a world-atlas geo feature to ISO alpha-3.
// world-atlas@2 uses numeric IDs (e.g. "404" for Kenya), not ISO_A3 properties.
import { numericToAlpha3 } from '../../../utils/countryMapping';

export function geoToISO3(geo) {
  return numericToAlpha3(geo.id) || geo.properties?.ISO_A3 || null;
}
